<form [formGroup]="form">
  <input
    [formControlName]="'search'"
    [placeholder]="'Szukaj' | translate"
  />
</form>
